import {Box} from "@mui/material"
import {CSSProperties, useState} from "react"
import darkenHexColor from "../../../helpers/convertHexcodeToDarker"

type Props = {
  style?: CSSProperties
  color: string
  index: number
  state: boolean
  active: boolean
  onClick: () => void
  setActive: (content: any) => void
}

const HotSpots: React.FC<Props> = (props) => {
  const style: React.CSSProperties = {
    ...props.style,
  }
  const color = props.color ? props.color : "#ba0e68"
  const [hover, setHover] = useState(false)

  let hotspotOpacity = {
    backgroundColor: props.color,
    border: "solid 3px #fff",
  }

  if (hover && !props.active && props.state) {
    hotspotOpacity.backgroundColor = darkenHexColor(color, -20)
  } else if (hover) {
    hotspotOpacity.backgroundColor = props.color
    hotspotOpacity.border = "solid 4px #fff"
  } else {
    hotspotOpacity.backgroundColor = props.color
  }

  const onActiveChange = () => {
    const active = !props.active ? true : false
    props.onClick()
    props.setActive({
      index: props.index,
      active: active,
    })
  }

  return (
    <Box
      onClick={() => onActiveChange()}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        minWidth: "16px",
        height: "16px",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        padding: "5px",
        borderRadius: "50%",
        cursor: "pointer",
        zIndex: 2,
        ...style,
      }}
    >
      <Box
        style={{
          minWidth: "16px",
          height: "16px",
          border: props.active
            ? "solid 4px #fff"
            : hotspotOpacity.border
            ? hotspotOpacity.border
            : "solid 3px #fff",
          borderRadius: "50%",
          backgroundColor: hotspotOpacity.backgroundColor,
        }}
      ></Box>
    </Box>
  )
}

export default HotSpots
